import request from '../request';

const getOptions = () => ({
  method: 'GET',
});

export default {
  fetch: (websiteId) => request(`/websites/${websiteId}`, getOptions()),
};
